export const cities = [
  "الرياض",
  "الخرج",
  "الدوادمي",
  "المجمعة",
  "القويعية",
  "وادي الدواسر",
  "الزلفي",
  "شقراء",
  "عفيف",
  "الرين",
  "الغاط",
  "الدرعية",
  "جدة",
  "مكة المكرمة",
  "الطائف",
  "القنفذة",
  "الجموم",
  "رابغ",
  "الليث",
  "خليص",
  "أضم",
  "تربة",
  "الخرمة",
  "رنية",
  "الكامل",
  "العرضيات",
  "الموية",
  "ميسان",
  "بحرة",
  "الدمام",
  "الخبر",
  "الظهران",
  "القطيف",
  "الأحساء",
  "الجبيل",
  "الخفجي",
  "بقيق",
  "أبها",
  "خميس مشيط",
  "بيشة",
  "محايل عسير",
  "بلقرن",
  "النماص",
  "سراة عبيدة",
  "طريب",
  "بارق",
  "تنومة",
  "تبوك",
  "ضباء",
  "حقل",
  "أملج",
  "الوجه",
  "البدع",
  "العيينة",
  "نجران",
  "شرورة",
  "بدر الجنوب",
  "يدمة",
  "حبونا",
  "ثار",
  "بريدة",
  "عنيزة",
  "الرس",
  "البكيرية",
  "المذنب",
  "البدائع",
  "العيون",
  "الباحة",
  "بلجرشي",
  "المندق",
  "العقيق",
  "قلوة",
  "المخواة",
  "الحجرة",
  "عرعر",
  "طريف",
  "العويقيلة",
  "رفحاء",
  "سكاكا",
  "دومة الجندل",
  "القريات",
  "طبرجل",
  "جازان",
  "صبيا",
  "أبو عريش",
  "بيش",
  "الدرب",
  "العارضة",
  "الحرث",
  "الطوال",
  "فيفاء",
  "الموسم",
  "الشقيري",
  "المدينة المنورة",
  "ينبع",
  "العلا",
  "مهد الذهب",
  "خيبر",
  "بدر",
  "الحناكية",
  "العيص",
  "وادي الفرع",
  "الرايس",
];
